export const API_URL = 'https://api1.sl-concept.pl/';
//export const API_URL = 'http://localhost:8022/';
export const RECAPTCHA_KEY = '6LfkXMcrAAAAADfOeKH3IC60puZeTiudA05yqZHc';
